var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLorryDefault = function SvgLorryDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M33.468 7.755c1.332 0 1.386-.004 2.742-.001.254 0 .44-.24.372-.484-.23-.82-.556-1.878-.857-2.59a.7.7 0 0 0-.568-.416c-.764-.09-1.477-.13-2.059-.159a.387.387 0 0 0-.405.387v2.49c0 .426.348.773.775.773Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeLinecap: "round",
    strokeWidth: 0.774,
    d: "M13.813 15.272h-3.196s-.402-.22-.402-.614v-2.083c0-.394.297-.726.69-.769l.25-.027a.8.8 0 0 1 .293.024l.83.231a.8.8 0 0 0 .209.029h13.855a.774.774 0 0 0 .774-.774V3.276c0-.428.346-.774.773-.774h1.767a.77.77 0 0 0 .583-.266l.355-.407a.77.77 0 0 1 .848-.218l4.982 1.815c.21.077.376.239.454.448.253.673.855 2.313 1.473 4.241q.023.075.032.152c.244 2.311.044 4.364 0 6.543a.787.787 0 0 1-.782.774h-1.1m-17.76-.103h12.515"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.8,
    d: "M17.198 15.894a.955.955 0 1 1-1.91 0 .955.955 0 0 1 1.91 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M18.564 15.894a2.322 2.322 0 1 1-4.644 0 2.322 2.322 0 0 1 4.644 0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.8,
    d: "M34.76 15.894a.955.955 0 1 1-1.909 0 .955.955 0 0 1 1.91 0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M36.127 15.894a2.322 2.322 0 1 1-4.645 0 2.322 2.322 0 0 1 4.645 0Z"
  })));
};
export default SvgLorryDefault;